import React, { Component } from 'react';
import { Steps, Divider, Button, Result, Row, Input, Select, Tooltip, Typography, Badge } from 'antd';
import DashboardLineChart from '../../../components/dashboard/line_chart';
import { Link } from 'react-router-dom';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { typeRepresentation, schema_to_field, overrideHeaderTitle, overrideHeaderBack } from '../../../lib/util';
import Form from '../../../lib/ui/form';
import lodash from 'lodash';
import { default_selections } from '../../../util/ui_util';
import ErrorWrapper from '../../../lib/error_wrapper'
import { BasicHeader } from '../../../components/basic_header';
import { Cancel } from '@material-ui/icons';
const { Paragraph, Text, Title } = Typography;

const { Step } = Steps;
const SUCCESS_STEPS = 5;
const ERROR_STEPS = 6;


const recon_add_list = [
    {
        title: "General",
        desc: "Basic Description"
    },
    {
        title: "Our Service",
        desc: "Our Service and Batcher"
    },
    {
        title: "Their Service",
        desc: "Their Service and Batcher"
    },
    {
        title: "Field Rules",
        desc: "Rules for Field Comparison"
    },
    {
        title: "Value Rules",
        desc: "Rules for Value Comparison"
    },
    // {
    //     title: "Manual Rules",
    //     desc: ""
    // }
]
class ReconcilerAddEdit extends Component {
    constructor(props) {
        super(props)

        this.group_id=props.match.params.group_id;


        this.state = {
            edit_id: this.props.edit_id || null,
            form_data: this.props.form_data || {
                field_comparisons: [],
                value_comparisons: []
            },
            our_data_type_options: {},
            our_service_options: {},
            their_data_type_options: {},
            their_service_options: {},
            step: 0,
            // to compare two fields
            field_comparators: {},

            // to compare value of field
            value_comparators: {},
            our_col_options: {},
            their_col_options: {},
            // our_col_options_key: {},
            // their_col_options_key: {},
            batchers: {},
            group_data:{}
        };

        this.get_group=RESTExecutor.detail().config({
            label:'reconciler_group_detail'
        }).forId(this.group_id).callbacks((success)=>{
                

            this.setState({group_data:success.result},()=>{
                this.handleServiceQuery(null, 'our_service_options', {});
                this.handleServiceQuery(null, 'their_service_options', {});
            });

        }).connect(props.domains.settings);
        this.get_group.execute()


        this.list_datatype = RESTExecutor.list().config({
            label: 'data_types',
        }).connect(props.domains.datatype);

        this.list_batcher = RESTExecutor.list().config({
            label: 'batchers',
            params: {
                pagination: false
            }
        }).callbacks((success) => {
            let batchers = {};
            success.result.rows.map((item) => {
                batchers[item.id] = item
            });
            this.setState({
                batchers: batchers
            })
        }).connect(props.domains.settings);

        this.list_comparators = RESTExecutor.list().config({
            label: 'reconciler_comparators',
            params: {
                pagination: false
            }
        })
            .callbacks((success) => {
                let field_comparator_obj = {};
                let value_comparator_obj = {};
                success.result.rows.map((item) => {
                    if (item.type === "field") {
                        field_comparator_obj[item.id] = item;
                        // value_comparator_obj[item.id] = item
                    } else if (item.type === "value") {
                        value_comparator_obj[item.id] = item
                    }
                });
                this.setState({
                    value_comparators: value_comparator_obj,
                    field_comparators: field_comparator_obj
                })
            })
            .connect(props.domains.settings);


        

        this.list_services = RESTExecutor.list().config({
            label: 'services_list'
        }).connect(props.domains.datatype);


        this.post_reconciliation_process = RESTExecutor.post().config({
            label: 'reconciler_rules'
        })
            .callbacks((success) => {
                this.setState({
                    step: SUCCESS_STEPS,
                })
            }, (error) => {
                let error_section = [];

                // console.log(Object.keys("dasdasd"))
                console.log("ERROR IS", error)
                if (error.validation_errors && typeof error.validation_errors === 'object' && Object.keys(error.validation_errors)) {
                    console.log("error is obj")
                    error_section.push(<Paragraph>
                        <Text
                            strong
                            style={{
                                fontSize: 16,
                            }}
                        >
                            The content you submitted has the following error:
                    </Text>

                    </Paragraph>)
                    Object.keys(error.validation_errors).map((key, index) => {
                        let error_item = error.validation_errors[key];
                        if (typeof error_item === 'string') {
                            error_section.push(
                                <Paragraph>
                                    <Cancel style={{ color: 'red' }} type="close-circle" /> {error_item}
                                </Paragraph>
                            )
                        }
                        else if (Array.isArray(error_item)) {
                            error_section.push(
                                <Paragraph>
                                    <Cancel style={{ color: 'red' }} type="close-circle" /> {error_item[0]}
                                </Paragraph>
                            )
                        }
                    })
                } else if (typeof error.error_message === 'string') {
                    error_section.push(<Paragraph>
                        <Cancel style={{ color: 'red' }} type="close-circle" /> {error.error_message}
                    </Paragraph>)
                }

                this.setState({
                    step: ERROR_STEPS,
                    error_section: error_section
                })
            })
            .connect(props.domains.settings);

        this.patch_reconciliation_process = RESTExecutor.patch().forId("").config({
            label: 'reconciler_rules_detail'
        })
            .callbacks(() => {
                this.setState({
                    step: SUCCESS_STEPS,
                })
            }, (error) => {
                let error_section = [];

                // console.log(Object.keys("dasdasd"))
                console.log("ERROR IS", error)
                if (error.validation_errors && typeof error.validation_errors === 'object' && Object.keys(error.validation_errors)) {
                    console.log("error is obj")
                    error_section.push(<Paragraph>
                        <Text
                            strong
                            style={{
                                fontSize: 16,
                            }}
                        >
                            The content you submitted has the following error:
                    </Text>

                    </Paragraph>)
                    Object.keys(error.validation_errors).map((key, index) => {
                        let error_item = error.validation_errors[key];
                        if (typeof error_item === 'string') {
                            error_section.push(
                                <Paragraph>
                                    <Cancel style={{ color: 'red' }} type="close-circle" /> {error_item}
                                </Paragraph>
                            )
                        }
                        else if (Array.isArray(error_item)) {
                            error_section.push(
                                <Paragraph>
                                    <Cancel style={{ color: 'red' }} type="close-circle" /> {error_item[0]}
                                </Paragraph>
                            )
                        }
                    })
                } else if (typeof error.error_message === 'string') {
                    error_section.push(<Paragraph>
                        <Cancel style={{ color: 'red' }} type="close-circle" /> {error.error_message}
                    </Paragraph>)
                }

                this.setState({
                    step: ERROR_STEPS,
                    error_section: error_section
                })
            })
            .connect(props.domains.settings);

        // if(this.state.edit_id)
        // this.handleSourceQuery(null, 'our_data_type_options', { id: this.state.form_data.our_data_type_id });
        // this.handleSourceQuery(null, 'their_data_type_options', { id: this.state.form_data.their_data_type_id });

        // if (this.state.form_data.our_data_type_id) {
        //     this.handleServiceQuery(null, 'our_service_options', { id: this.state.form_data.our_data_service_id });

        // }
        // if (this.state.form_data.their_data_type_id) {
        //     this.handleServiceQuery(null, 'their_service_options', { id: this.state.form_data.their_data_service_id });
        // }

        this.list_batcher.execute();


    };

    _generateValidationForm = (config, data, onChange) => {
        let schema = config || [];
        let fields = schema_to_field(schema);

        return <Form
            forCreate={true}
            initialData={data}
            submitted={false}
            onChange={onChange}
            fields={fields}
            errorMessage={{}}
            validationError={{}}
        />

    }

    handlePostPatch = () => {
        if (this.state.edit_id) {
            // patch/edit
            this.patch_reconciliation_process.config({
                params:{
                    group_id:this.group_id,
                    recon_id:this.state.edit_id
                }
            }).execute(this.state.form_data);

        } else {
            this.post_reconciliation_process.forId(this.group_id).execute(this.state.form_data)
            // post/add
        }
    }

    changeColumnsOptions = (stateKey, field_cols_obj = [], sourceType) => {

        let initial_options = [];

        field_cols_obj.map((item) => {
            // let item=field_cols_obj[key];

            initial_options.push({
                display_name: item.display_name || item.name.toUpperCase(),
                key: item.name,
                type: item.validation.type
            })
        });

        let final_options = [...initial_options, ...default_selections];


        // console.log(stateKey, field_cols_obj);
        // let a = 'our_data_type_options';
        // let b = 'their_data_type_options';
        // let c = {};
        // let col_obj_key = {};
        // cols_array.map((item) => {
        //     col_obj_key[item.key] = item
        // });
        // if (stateKey === a) {
        //     c['our_data_type_options_key'] = col_obj_key;
        // } else if (stateKey === b) {
        //     c['their_data_type_options_key'] = col_obj_key;
        // }
        let col_obj = lodash.groupBy(final_options, (item) => item.type);
        this.setState({
            [stateKey]: col_obj,
            // ...c
        })
    }




    handleSourceQuery = (value, stateKey, param = {}) => {
        this.list_datatype.config({
            params: {
                query: value,
                ...param
            }
        }).callbacks((success) => {
            let source_data = {};
            let our_data_type_id = this.state.form_data.our_data_type_id;
            let their_data_type_id = this.state.form_data.their_data_type_id;

            success.result.rows.map((item) => {
                source_data[item.id] = item;

                // if (our_data_type_id && our_data_type_id === item.id) {
                //     this.changeColumnsOptions('our_col_options', item.columns)
                // }
                // if (their_data_type_id && their_data_type_id === item.id) {
                //     this.changeColumnsOptions('their_col_options', item.columns)
                // }
            });
            this.setState({
                [stateKey]: source_data
            })
        }).execute()
    }

    handleServiceQuery = (value, stateKey, param = {}) => {

        let id = "";
        console.log(value, stateKey)
        if (stateKey === "our_service_options") {
            id = this.state.group_data.our_data_type_id;
        } else if (stateKey === "their_service_options") {
            id = this.state.group_data.their_data_type_id;
        }
        this.list_services.config({
            params: {
                query: value,
                ...param,
                pagination:false
            }
        }).forId(id)
            .callbacks((success) => {
                let service_data = {};
                let our_data_service_id = this.state.form_data.our_data_service_id;
                let their_data_service_id = this.state.form_data.their_data_service_id;

                success.result.rows.map((item) => {
                    service_data[item.id] = item;

                    if (our_data_service_id && our_data_service_id === item.id) {

                        this.changeColumnsOptions('our_col_options', item.fields_config)
                    }
                    if (their_data_service_id && their_data_service_id === item.id) {
                        this.changeColumnsOptions('their_col_options', item.fields_config)
                    }
                });

                this.setState({
                    [stateKey]: service_data
                })
            }).execute()
    }



    rulesChanger = (key, value, index) => {
        let form_data = this.state.form_data;
        switch (key) {
            case 'comparator':
                form_data.field_comparisons[index] = {
                    comparator: value
                }
                break;
            // case 'our_column':
            //     form_data.field_comparisons[index]={
            //         ...form_data.field_comparisons[index],
            //         their_column:null,
            //         [key]:value
            //     }
            //     break;
            // case 'their_column':
            //     form_data.field_comparisons[index]={
            //         ...form_data.field_comparisons[index],
            //         our_column:null,
            //         [key]:value
            //     }
            //     break;
            default:
                form_data.field_comparisons[index][key] = value;
                break;
        }

        this.setState({
            form_data: form_data
        })

    }
    rulesAdder = () => {
        let form_data = this.state.form_data;
        if (form_data.field_comparisons) {
            form_data.field_comparisons.push({})
        }
        this.setState({
            form_data: form_data
        })

    }
    rulesDeleter = (index) => {
        let form_data = this.state.form_data;
        if (Array.isArray(form_data.field_comparisons)) {
            form_data.field_comparisons.splice(index, 1);
        }
        this.setState({
            form_data: form_data
        })
    }


    fieldRulesChanger = (key, value, index) => {
        let form_data = this.state.form_data;
        switch (key) {
            case 'comparator':
                form_data.value_comparisons[index] = {
                    comparator: value
                }
                break;
            case 'for':
                form_data.value_comparisons[index] = {
                    ...form_data.value_comparisons[index],
                    column: null,
                    [key]: value
                }
                break;
            default:
                form_data.value_comparisons[index][key] = value;
                break;
        }

        this.setState({
            form_data: form_data
        })

    }
    fieldRulesAdder = () => {
        let form_data = this.state.form_data;
        if (form_data.value_comparisons) {
            form_data.value_comparisons.push({})
        }
        this.setState({
            form_data: form_data
        })

    }
    fieldRulesDeleter = (index) => {
        let form_data = this.state.form_data;
        if (Array.isArray(form_data.value_comparisons)) {
            form_data.value_comparisons.splice(index, 1);
        }
        this.setState({
            form_data: form_data
        })
    }

    stateUpdater = (stateKey, key, value, callback, resetValueRules, resetFieldRules) => {
        let newData = this.state[stateKey];


        // Change column option here
        if (key === 'our_data_service_id' && value != null) {
            let item = this.state.our_service_options[value] || {};
            this.changeColumnsOptions('our_col_options', item.fields_config)
        }
        else if (key === 'their_data_service_id' && value != null) {
            let item = this.state.their_service_options[value] || {};
            this.changeColumnsOptions('their_col_options', item.fields_config)
        }

        newData[key] = value;
        if (resetValueRules) {
            newData.field_comparisons = []
        }
        if (resetFieldRules) {
            newData.value_comparisons = []
        }
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        });



    }

    _generateValidationForm = (config, data, onChange) => {
        let schema = config || [];
        let fields = schema_to_field(schema);
        return <Form
            forCreate={true}
            initialData={data}
            submitted={false}
            onChange={onChange}
            fields={fields}
            errorMessage={{}}
            validationError={{}}
        />

    }

    _renderStepsFooter = (currentStep) => {
        return <Row type='flex' justify='space-between' style={{
            paddingLeft: 8,
            paddingRight: 8
        }}>
            <div>
                {currentStep !== 0 && <Button type='link' style={{ color: 'red' }}
                    onClick={() => {
                        this.setState({
                            step: this.state.step - 1
                        })
                    }}
                >Previous</Button>}
            </div>

            <div>
                {currentStep !== (recon_add_list.length - 1) && <Button type='primary'
                    onClick={() => {
                        this.setState({
                            step: this.state.step + 1
                        })
                    }}
                >Next</Button>}
                {currentStep === (recon_add_list.length - 1) && <Button type='primary'
                    onClick={() => {
                        this.handlePostPatch()
                    }}
                >Submit</Button>}
                {this.state.edit_id && currentStep !== (recon_add_list.length - 1) && <Button type='link'
                    onClick={() => {
                        this.setState({
                            step: recon_add_list.length - 1
                        })
                    }}
                >Skip</Button>
                }

            </div>
        </Row>
    }


    _renderStepsContent = ({ step = 0, desc = "", itemIndex, our_data_type_options, our_service_options, their_service_options, their_data_type_options }) => {
        // let step = this.state.step;
        if (step === itemIndex) {
            let form_data = this.state.form_data;
            let value_comparators = this.state.value_comparators || {};
            let field_comparators = this.state.field_comparators || {};
            let our_col_options = this.state.our_col_options;
            let their_col_options = this.state.their_col_options;
            let batchers = this.state.batchers;



            switch (step) {
                case 0:

                    return <div><Row type='flex' justify='center'>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: 'fit-content',
                            textAlign: 'right'
                        }}
                        >
                            <span>Reconcilier Name: &nbsp; <Input
                                placeholder={"Reconciler Process Name"}
                                onChange={(e) => {
                                    this.stateUpdater('form_data', 'name', e.target.value)
                                }}
                                value={form_data.name}
                                style={{
                                    width: 300
                                }} >
                            </Input>
                            </span>
                           


                        </div>

                    </Row>
                        <br></br>
                        <br></br>
                        {this._renderStepsFooter(0)}
                    </div>
                case 1:
                    // let our_data_type_options = this.state.our_data_type_options;
                    // let our_service_options = this.state.our_service_options;

                    return (<div>
                        <Row type='flex' justify='center'>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: 'fit-content',
                                textAlign: 'right'
                            }}
                            >
                                {/* <span>Our Datatype: &nbsp;
                            <Select placeholder="Our Datatype " style={{
                                        width: 300
                                    }}
                                        value={form_data.our_data_type_id}
                                        onChange={(value) => {
                                            this.stateUpdater('form_data', 'our_data_type_id', value);
                                            this.handleServiceQuery(null, 'our_service_options', { id: value });

                                        }}
                                        showSearch
                                        filterOption={false}
                                        // loading={list_extension_resp.fetching}
                                        onSearch={(value) => {
                                            this.handleSourceQuery(value, 'our_data_type_options');
                                            // this.list_extensions.config({
                                            //     params: {
                                            //         query: value
                                            //     }
                                            // }).execute()
                                        }}
                                    >
                                        {Object.keys(our_data_type_options).map((key, index) => {
                                            let item = our_data_type_options[key];
                                            return <Select.Option value={item.id} key={item.id}>
                                                {item.name}
                                            </Select.Option>
                                        })}
                                    </Select>
                                </span>
                                <br></br> */}
                                <span>Our Service: &nbsp;
                            <Select placeholder="Our Service " style={{
                                        width: 300
                                    }}
                                        value={form_data.our_data_service_id}
                                        onChange={(value) => {
                                            this.stateUpdater('form_data', 'our_data_service_id', value)
                                        }}
                                        showSearch
                                        filterOption={false}
                                        // loading={list_extension_resp.fetching}
                                        onSearch={(value) => {
                                            this.handleServiceQuery(value, 'our_service_options')
                                            // this.list_extensions.config({
                                            //     params: {
                                            //         query: value
                                            //     }
                                            // }).execute()
                                        }}
                                    >
                                        {Object.keys(our_service_options).map((key, index) => {
                                            let item = our_service_options[key];
                                            return <Select.Option value={item.id} key={item.id}>
                                                {item.name}
                                            </Select.Option>
                                        })}
                                        {/* {our_service_options.map((item) => {
                                            return <Select.Option value={item.id} key={item.id}>
                                                {item.name}
                                            </Select.Option>
                                        })} */}
                                    </Select>
                                </span>
                                <br></br>
                                <span>Our Batcher: &nbsp;
                                <Select placeholder="Our Batcher " style={{
                                        width: 300
                                    }}
                                        value={form_data.our_batcher}
                                        onChange={(value) => {
                                            this.stateUpdater('form_data', 'our_batcher', value);
                                            // this.handleServiceQuery(null, 'our_service_options', { id: value });

                                        }}
                                        showSearch
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {Object.keys(batchers).map((key, index) => {
                                            let item = batchers[key];
                                            return <Select.Option value={item.id} key={item.id}>
                                                {item.name}
                                            </Select.Option>
                                        })}
                                    </Select>
                                </span>
                                <br></br>
                            </div>
                        </Row>
                        {batchers[form_data.our_batcher] && batchers[form_data.our_batcher].validation_config &&
                            Object.keys(batchers[form_data.our_batcher].validation_config).length > 0
                            && <div>
                                <Title type='secondary' level={4} underline>Validations</Title>

                                {this._generateValidationForm(batchers[form_data.our_batcher].validation_config, form_data.our_batcher_params || {}, (data) => {
                                    this.stateUpdater('form_data', 'our_batcher_params', data);
                                })}
                            </div>
                        }

                        <br></br>
                        <br></br>
                        {this._renderStepsFooter(1)}
                    </div>)

                case 2:
                    // let their_data_type_options = this.state.their_data_type_options;
                    // let their_service_options = this.state.their_service_options;

                    return (<div>
                        <Row type='flex' justify='center'>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: 'fit-content',
                                textAlign: 'right'
                            }}
                            >
                                {/* <span>Their Datatype: &nbsp;
                                    <Select placeholder="Their Datatype " style={{
                                        width: 300
                                    }}
                                        value={form_data.their_data_type_id}

                                        onChange={(value) => {
                                            this.stateUpdater('form_data', 'their_data_type_id', value);
                                            this.handleServiceQuery(null, 'their_service_options', { id: value });
                                        }}
                                        showSearch
                                        filterOption={false}
                                        // loading={list_extension_resp.fetching}
                                        onSearch={(value) => {
                                            this.handleSourceQuery(value, 'their_data_type_options')
                                            // this.list_extensions.config({
                                            //     params: {
                                            //         query: value
                                            //     }
                                            // }).execute()
                                        }}
                                    >
                                        {Object.keys(their_data_type_options).map((key, index) => {
                                            let item = their_data_type_options[key];
                                            return <Select.Option value={item.id} key={item.id}>
                                                {item.name}
                                            </Select.Option>
                                        })}
                                    </Select>
                                </span>
                                <br></br> */}
                                <span>Their Service: &nbsp;
                    <Select placeholder="Their Service " style={{
                                        width: 300
                                    }}
                                        value={form_data.their_data_service_id}
                                        onChange={(value) => {
                                            this.stateUpdater('form_data', 'their_data_service_id', value);

                                        }}
                                        showSearch
                                        filterOption={false}
                                        onSearch={(value) => {
                                            this.handleServiceQuery(value, 'their_service_options')
                                        }}
                                    >

                                        {Object.keys(their_service_options).map((key, index) => {
                                            let item = their_service_options[key];
                                            return <Select.Option value={item.id} key={item.id}>
                                                {item.name}
                                            </Select.Option>
                                        })}
                                        {/* {their_service_options.map((item) => {
                                            return <Select.Option value={item.id} key={item.id}>
                                                {item.name}
                                            </Select.Option>
                                        })} */}
                                    </Select>
                                </span>
                                <br></br>
                                <span>Their Batcher: &nbsp;
                                <Select placeholder="Their Batcher " style={{
                                        width: 300
                                    }}
                                        value={form_data.their_batcher}
                                        onChange={(value) => {
                                            this.stateUpdater('form_data', 'their_batcher', value);
                                        }}
                                        showSearch
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {Object.keys(batchers).map((key, index) => {
                                            let item = batchers[key];
                                            return <Select.Option value={item.id} key={item.id}>
                                                {item.name}
                                            </Select.Option>
                                        })}
                                    </Select>
                                </span>
                                <br></br>
                            </div>
                        </Row>
                        {batchers[form_data.their_batcher] && batchers[form_data.their_batcher].validation_config &&
                            Object.keys(batchers[form_data.their_batcher].validation_config).length > 0
                            && <div>
                                <Title type='secondary' level={4} underline>Validations</Title>

                                {this._generateValidationForm(batchers[form_data.their_batcher].validation_config, form_data.their_batcher_params || {}, (data) => {
                                    this.stateUpdater('form_data', 'their_batcher_params', data);
                                })}
                            </div>
                        }
                        <br></br>
                        <br></br>
                        {this._renderStepsFooter(2)}
                    </div>)

                case 3:
                    return <div>
                        {/* {form_data.field_comparisons && form_data.field_comparisons.length > 0 && <Row type='flex' justify='space-between' style={{
                            flexWrap: 'nowrap'
                        }}>
                            <Row type='flex'
                                justify='space-between'
                                style={{
                                    width: '100%',
                                    marginTop: 4,

                                    marginBottom: 4,
                                }}>
                                <span style={{
                                    width: 300,
                                    paddingRight: 4
                                }}>
                                    <Text>Our Column</Text>
                                </span>
                                <span style={{
                                    width: 300,
                                    paddingRight: 4
                                }}>
                                    <Text>Comparator</Text>
                                </span>
                                <span style={{
                                    width: 300,
                                    paddingRight: 4
                                }}>
                                    <Text>Their Column</Text>
                                </span>


                            </Row>

                            <Button type='link' style={{
                                color: 'red',
                                opacity: 0
                            }}>x</Button>

                        </Row>} */}

                        {form_data.field_comparisons && form_data.field_comparisons.map((item, index) => {

                            let item_comparator_id = item.comparator;

                            let _our_col_selections = [];
                            let _their_col_selections = [];
                            let our_col_selections = [];
                            let their_col_selections = [];


                            if (item_comparator_id) {
                                console.log(item_comparator_id, field_comparators, field_comparators[item_comparator_id])
                                let supported_type = (field_comparators[item_comparator_id] && field_comparators[item_comparator_id].supported_types) || [];
                                supported_type.map((data_type) => {
                                    let supported_ours = our_col_options[data_type] || [];
                                    _our_col_selections = _our_col_selections.concat(supported_ours);
                                    let supported_theirs = their_col_options[data_type] || [];
                                    _their_col_selections = _their_col_selections.concat(supported_theirs);

                                    console.log("assigning data", _our_col_selections, _their_col_selections)
                                });
                                our_col_selections = _our_col_selections;
                                their_col_selections = _their_col_selections;

                                // if((!item.our_column && !item.their_column)||(item.our_column && item.their_column)){
                                //     our_col_selections =_our_col_selections;
                                //     their_col_selections=_their_col_selections;
                                //     console.log("has all column",their_col_selections,our_col_selections)

                                // }else if(item.our_column){
                                //     let our_col=_our_col_selections.find((item)=>{return item.key===item.our_column})||{};

                                //     our_col_selections =_our_col_selections;
                                //     their_col_selections=_their_col_selections.filter((item)=>{
                                //         return item.type===our_col.type;
                                //     });
                                //     console.log("has our column",their_col_selections,our_col_selections)


                                // }else if(item.their_column){
                                //     let their_col=_our_col_selections.find((item)=>{return item.key===item.our_column})||{};

                                //     their_col_selections =_their_col_selections;
                                //     our_col_selections=_our_col_selections.filter((item)=>{
                                //         return item.type===their_col.type;
                                //     });
                                //     console.log("has their column",their_col_selections,our_col_selections)
                                // }

                            }

                            return <div style={{
                                border: '1px solid #ddd',
                                marginBottom: 24,
                                padding: 12,
                                borderRadius:10
                            }}>
                                <Row type='flex' justify='space-between' key={index} style={{
                                    flexWrap: 'nowrap'
                                }}>
                                    <Row type='flex' style={{
                                        flex: 1
                                    }} justify='center'>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: 'fit-content',
                                            textAlign: 'right'
                                        }}>
                                            <span>Field Comparator: &nbsp;
                                    <Select placeholder="Comparator" style={{
                                                    width: 300,
                                                    paddingRight: 4
                                                }}
                                                    value={item.comparator}
                                                    onChange={(value) => {
                                                        this.rulesChanger('comparator', value, index)
                                                        this.rulesChanger('params', {}, index);
                                                        // this.stateUpdater('form_data', 'their_data_service_id', value)
                                                    }}
                                                    showSearch
                                                    filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                >
                                                    {Object.keys(field_comparators).map((key, comp_index) => {
                                                        let item = field_comparators[key] || {};
                                                        return <Select.Option value={item.id} key={comp_index}>
                                                            {item.name}
                                                        </Select.Option>
                                                    })}
                                                </Select>
                                            </span>

                                            <br></br>
                                            <span>Our Column: &nbsp;
                                    <Select placeholder="Our Column" style={{
                                                    width: 300,
                                                    paddingRight: 4
                                                }}
                                                    value={item.our_column}
                                                    onChange={(value) => {
                                                        this.rulesChanger('our_column', value, index)
                                                        // this.stateUpdater('form_data', 'their_data_service_id', value)
                                                    }}
                                                    showSearch
                                                    filterOption={(input, option) => {
                                                        console.log("option", option);
                                                        // return true;
                                                        return (option.props.children[0] || "").toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }}
                                                >
                                                    {our_col_selections.map((item) => {
                                                        return <Select.Option value={item.key} key={item.key}>
                                                            {item.display_name} <Badge style={{ backgroundColor: '#52c41a' }} count={item.type} />
                                                        </Select.Option>
                                                    })}
                                                    {/* {our_data_type_options[form_data.our_data_type_id] && Array.isArray(our_data_type_options[form_data.our_data_type_id].columns) &&
                                            our_data_type_options[form_data.our_data_type_id].columns.map((item, our_col_index) => {
                                                return <Select.Option value={item.key} key={our_col_index}>
                                                    {item.display_name}
                                                </Select.Option>
                                            })} */}
                                                </Select>
                                            </span>
                                            <br></br>
                                            <span>Their Column: &nbsp;
                                    <Select placeholder="Their Column" style={{
                                                    width: 300,
                                                    paddingRight: 4
                                                }}
                                                    value={item.their_column}
                                                    onChange={(value) => {
                                                        this.rulesChanger('their_column', value, index)
                                                        // this.stateUpdater('form_data', 'their_data_service_id', value)
                                                    }}
                                                    showSearch
                                                    filterOption={(input, option) => {

                                                        return (option.props.children[0] || "").toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }}
                                                >
                                                    {their_col_selections.map((item) => {
                                                        return <Select.Option value={item.key} key={item.key}>
                                                            {item.display_name} <Badge style={{ backgroundColor: '#52c41a' }} count={item.type} />
                                                        </Select.Option>
                                                    })}
                                                    {/* {their_data_type_options[form_data.their_data_type_id] && Array.isArray(their_data_type_options[form_data.their_data_type_id].columns) &&
                                                their_data_type_options[form_data.their_data_type_id].columns.map((item, their_col_index) => {
                                                    return <Select.Option value={item.key} key={their_col_index}>
                                                        {item.display_name}
                                                    </Select.Option>
                                                })} */}
                                                </Select>
                                            </span>

                                        </div>
                                    </Row>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: 1
                                    }}>
                                        {field_comparators[item.comparator] && field_comparators[item.comparator].validation_config &&
                                            Object.keys(field_comparators[item.comparator].validation_config).length > 0
                                            && <div style={{
                                                // paddingLeft:30,
                                                // paddingRight:30
                                                borderLeft: '1px solid #00000045',
                                                paddingLeft: 16,
                                                marginLeft:16,
                                                height: '100%'

                                                // padding:16,
                                                // borderRadius:20

                                            }}>
                                                <Title type='secondary' level={4} style={{ margin: 0 }} underline>Validation Parameter</Title>

                                                {this._generateValidationForm(field_comparators[item.comparator].validation_config, item.params || {}, (data) => {
                                                    this.rulesChanger('params', data, index)
                                                })}
                                            </div>}

                                    </div>
                                    <div>
                                        <Tooltip title="Delete this rule">
                                            <Button type='link'
                                                onClick={() => {
                                                    this.rulesDeleter(index)
                                                }}
                                                style={{
                                                    color: 'red',
                                                    fontSize: 30
                                                }}>x</Button>
                                        </Tooltip>
                                    </div>
                                </Row>
                                {/* <Divider style={{ marginTop: 8, marginBottom: 8 }} /> */}
                            </div>

                        })}

                        <center><Button type='link' onClick={() => {
                            this.rulesAdder()
                        }}>Add New Rule</Button></center>
                        <br></br>
                        <br></br>
                        {this._renderStepsFooter(3)}
                    </div>
                case 4:
                    return <div>
                        {form_data.value_comparisons && form_data.value_comparisons.map((item, index) => {
                            let item_comparator_id = item.comparator;

                            let _our_col_selections = [];
                            let _their_col_selections = [];
                            let our_col_selections = [];
                            let their_col_selections = [];


                            if (item_comparator_id) {
                                // console.log(item_comparator_id, comparators, comparators[item_comparator_id])
                                let supported_type = (value_comparators[item_comparator_id] && value_comparators[item_comparator_id].supported_types) || [];
                                supported_type.map((data_type) => {
                                    let supported_ours = our_col_options[data_type] || [];
                                    _our_col_selections = _our_col_selections.concat(supported_ours);
                                    let supported_theirs = their_col_options[data_type] || [];
                                    _their_col_selections = _their_col_selections.concat(supported_theirs);
                                    console.log("assigning data", _our_col_selections, _their_col_selections)
                                });
                                our_col_selections = _our_col_selections;
                                their_col_selections = _their_col_selections;
                            }


                            return <div style={{
                                border: '1px solid #ddd',
                                marginBottom: 24,
                                padding: 12,
                                borderRadius:10
                            }}>

                                <Row type='flex' justify='space-between' key={index} style={{
                                    flexWrap: 'nowrap'
                                }}>
                                    <Row type='flex' style={{
                                        flex: 1
                                    }} justify='center'>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: 'fit-content',
                                            textAlign: 'right'
                                        }}
                                        >
                                            <span>Value Comparator: &nbsp;
                                            <Select placeholder="Comparator" style={{
                                                    width: 300,
                                                    paddingRight: 4
                                                }}
                                                    value={item.comparator}
                                                    onChange={(value) => {
                                                        this.fieldRulesChanger('comparator', value, index)
                                                        this.fieldRulesChanger('params', {}, index);
                                                        // this.stateUpdater('form_data', 'their_data_service_id', value)
                                                    }}
                                                    showSearch
                                                    filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                >
                                                    {Object.keys(value_comparators).map((key, comp_index) => {
                                                        let item = value_comparators[key] || {};
                                                        return <Select.Option value={item.id} key={comp_index}>
                                                            {item.name}
                                                        </Select.Option>
                                                    })}
                                                </Select>
                                            </span>
                                            <br></br>
                                            {item.comparator &&<React.Fragment>
                                                <span>For Data Type: &nbsp;
                                            <Select placeholder="For Data Type" style={{
                                                        width: 300,
                                                        paddingRight: 4
                                                    }}
                                                        value={item.for}
                                                        onChange={(value) => {
                                                            console.log("changed", value)
                                                            this.fieldRulesChanger('for', value, index)
                                                            // this.stateUpdater('form_data', 'their_data_service_id', value)
                                                        }}
                                                    // showSearch
                                                    // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                    >
                                                        <Select.Option value={'our'} key={'our'}>
                                                            Our Data Type
                        </Select.Option>
                                                        <Select.Option value={'their'} key={'their'}>
                                                            Their Data Type
                        </Select.Option>
                                                    </Select>
                                                </span>
                                                <br></br>
                                                </React.Fragment>
                                            }
                                            {
                                                item.for === 'our' ?
                                                    <React.Fragment>
                                                        <span>Our Column: &nbsp;
            <Select placeholder="Our Column" style={{
                                                                width: 300,
                                                                paddingRight: 4
                                                            }}
                                                                value={item.column}
                                                                onChange={(value) => {
                                                                    this.fieldRulesChanger('column', value, index)
                                                                    // this.stateUpdater('form_data', 'their_data_service_id', value)
                                                                }}
                                                                showSearch
                                                                filterOption={(input, option) => {
                                                                    return (option.props.children[0] || "").toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }}
                                                            >
                                                                {our_col_selections.map((item) => {
                                                                    return <Select.Option value={item.key} key={item.key}>
                                                                        {item.display_name} <Badge style={{ backgroundColor: '#52c41a' }} count={item.type} />
                                                                    </Select.Option>
                                                                })}
                                                            </Select>
                                                        </span>
                                                        <br></br>
                                                    </React.Fragment>
                                                    : item.for === 'their' ? <React.Fragment>
                                                        <span>Their Column: &nbsp;
            <Select placeholder="Their Column" style={{
                                                                width: 300,
                                                                paddingRight: 4
                                                            }}
                                                                value={item.column}
                                                                onChange={(value) => {
                                                                    this.fieldRulesChanger('column', value, index)
                                                                    // this.stateUpdater('form_data', 'their_data_service_id', value)
                                                                }}
                                                                showSearch
                                                                filterOption={(input, option) => {
                                                                    return (option.props.children[0] || "").toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }}
                                                            >
                                                                {their_col_selections.map((item) => {
                                                                    return <Select.Option value={item.key} key={item.key}>
                                                                        {item.display_name} <Badge style={{ backgroundColor: '#52c41a' }} count={item.type} />
                                                                    </Select.Option>
                                                                })}
                                                            </Select>
                                                        </span>
                                                        <br></br>
                                                    </React.Fragment> : null

                                            }
                                        </div>
                                    </Row>

                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: 1
                                    }}>
                                    {value_comparators[item.comparator] && value_comparators[item.comparator].validation_config &&
                                    Object.keys(value_comparators[item.comparator].validation_config).length > 0
                                    && <div style={{
                                        // paddingLeft:30,
                                        // paddingRight:30
                                        borderLeft: '1px solid #00000045',
                                        paddingLeft: 16,
                                        marginLeft:16,
                                        height: '100%'
                                    }}>
                                        <Title type='secondary' level={4} underline>Validation Paramater</Title>

                                        {this._generateValidationForm(value_comparators[item.comparator].validation_config, item.params || {}, (data) => {
                                            this.fieldRulesChanger('params', data, index)
                                        })}
                                    </div>}

                            </div>
                                    <div>
                                    <Tooltip title="Delete this rule">
                                        <Button type='link'
                                            onClick={() => {
                                                this.fieldRulesDeleter(index)
                                            }}
                                            style={{
                                                color: 'red',
                                                fontSize:30
                                            }}>x</Button>
                                    </Tooltip>
                                    </div>
                                </Row>
                                </div>
                        })}
                        <center><Button type='link' onClick={() => {
                            this.fieldRulesAdder()
                        }}>Add New Rule</Button></center>
                        <br></br>
                        <br></br>
                        {this._renderStepsFooter(4)}
                    </div>
                // case 5:
                //     return <div>

                //         <Form
                //         hideTitle
                //         forCreate={true}
                //         initialData={form_data.manual_rules}
                //         submitted={this.state.submitted}
                //         onChange={(data) => {
                //             console.log("Changes", data);
                //             this.has_changed = true
                //             this.stateUpdater('form_data', 'manual_rules', data)

                //         }}
                //         fields={[{index:'maker_checker',name:"Maker Checker",type:'bool'}

                //         ]}
                //         submitting={{}}
                //         errorMessage={{}}
                //         validationErrors={{}}
                //         />


                //         {this._renderStepsFooter(5)}
                //     </div>
                
                case SUCCESS_STEPS:
                    return <div> <Result
                        status="success"
                        title="Successfully completed operation on Reconciliation Process"
                        // subTitle=""
                        extra={[
                            <Link to={`/settings/reconcilers-group/${this.group_id}`}>
                                <Button type="primary" key="console">
                                    Go to Reconcilers
                            </Button></Link>,
                            <Button key="add_again" onClick={() => {
                                this.setState({
                                    step: 0,
                                    form_data: {
                                        field_comparisons: [],
                                        value_comparisons: [],
                                    },
                                    our_col_options: {},
                                    their_col_options: {},
                                    edit_id: null
                                })
                            }}>Add Again</Button>,
                        ]}
                    />

                    </div>
                case ERROR_STEPS:
                    return <div> <Result

                        status='error'
                        title="Operation Failed"
                        subTitle="Please check and modify the following information before resubmitting."
                        // subTitle=""
                        extra={[
                            <Link to={`/settings/reconcilers-group/${this.group_id}`}>
                                <Button type='dashed' key="console">
                                    Go to Reconcilers
                        </Button></Link>,

                            <Button key="try_again" type='primary' onClick={() => {
                                this.setState({
                                    step: 0
                                })
                            }}>Try Again</Button>,
                        ]}
                    />
                        <div className="desc" style={{
                            textAlign: 'left'
                        }}>
                            {this.state.error_section}
                        </div>

                    </div>
                default:
                    return <div>{desc}</div>
            }
        }

        return <div>{desc}</div>

    }

    _getStepsStatus = (stepIndex) => {

        let form_data = this.state.form_data;
        let step = this.state.step;

        switch (stepIndex) {
            case 0:
                if ((form_data.name == null || form_data.name == "") && step > 0) {
                    return 'error';
                } else return null;
            case 1:
                if ((form_data.our_data_service_id == null) && step > 1) {
                    return 'error'
                } else return null;
            case 2:
                if ((form_data.their_data_service_id == null) && step > 2) {
                    return 'error'
                } else return null;
            // case 3:
            //         if ((!form_data.field_comparisons || !(Array.isArray(form_data.field_comparisons))) && step > 3) {
            //             return 'error'
            //     } else return null;

            default: return null;
        }

    }

    render() {
        const { step, edit_id, form_data, our_service_options, our_data_type_options, their_service_options, their_data_type_options } = this.state;
        let get_group_resp=this.get_group.response();

        return (
            <ErrorWrapper error={get_group_resp} onReload={()=>{
                this.get_group.forId(this.group_id).execute()
            }}>
                <BasicHeader
                title={`Reconciler Rule ${edit_id?"Edit":"Add"}`}
                />
            <div className='default-card' style={{
                padding: 8,
                textAlign: null
            }}>
                {/* <CustomHeader
                    title={`Reconciler ${edit_id ? "Edit" : "Add"}`}
                /> */}
                {/* <Divider /> */}
                {step === SUCCESS_STEPS ? <div> <Result
                    status="success"
                    title="Successfully completed operation on Reconciliation Process"
                    // subTitle=""
                    extra={[
                        <Link to={`/settings/reconcilers`}>
                            <Button type='dashed' key="console">
                                Go to Reconcilers
                            </Button></Link>,
                        <Button key="add_again" type='primary' onClick={() => {
                            this.setState({
                                step: 0,
                                form_data: {
                                    field_comparisons: [],
                                    value_comparisons: []
                                },
                                our_col_options: {},
                                their_col_options: {},
                                edit_id: null,
                            })
                        }}>Add Again</Button>,
                    ]}
                />

                </div> :
                    step === ERROR_STEPS ?
                        <div> <Result

                            status='error'
                            title="Operation Failed"
                            subTitle="Please check and modify the following information before resubmitting."
                            // subTitle=""
                            extra={[
                                <Link to={`/settings/reconcilers`}>
                                    <Button type='dashed' key="console">
                                        Go to Reconcilers
                        </Button></Link>,

                                <Button key="try_again"  type='primary' onClick={() => {
                                    this.setState({
                                        step: 0
                                    })
                                }}>Try Again</Button>,
                            ]}
                        />
                            <div className="desc" style={{
                                textAlign: 'left'
                            }}>
                                {this.state.error_section}
                            </div>

                        </div>
                        :
                        <Steps current={step} direction="vertical" onChange={(current) => {
                            console.log("change step tp", current);
                            this.setState({ step: current })
                        }}>
                            {
                                recon_add_list.map((item, index) => {
                                    return <Step status={this._getStepsStatus(index)} title={item.title} description={
                                        <div style={{
                                            padding: 8,
                                            paddingLeft: 20,
                                            paddingRight: 20
                                        }}>
                                            {this._renderStepsContent({
                                                step: step,
                                                desc: item.desc,
                                                itemIndex: index,
                                                our_service_options: our_service_options,
                                                our_data_type_options: our_data_type_options,
                                                their_data_type_options: their_data_type_options,
                                                their_service_options: their_service_options
                                            })}

                                        </div>
                                    } />
                                })
                            }
                        </Steps>
                }

            </div>
            </ErrorWrapper>
            
      );    
    }

    componentDidMount() {
        this.list_comparators.execute();

        overrideHeaderTitle(`Reconciler ${this.props.edit_id?"Edit":"Add"}`)
        overrideHeaderBack(`/settings/reconcilers-group/${this.props.match.params.group_id}`)
       
    }
    componentWillUnmount(){
        overrideHeaderBack(null)
    }

    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.form_data != prevProps.form_data || this.props.edit_id != prevProps.edit_id||(this.props.match.params.group_id!=prevProps.match.params.group_id)) {
            console.log("updated",this.props.match.params)
            overrideHeaderTitle(`Reconciler ${this.props.edit_id?"Edit":"Add"}`)
            overrideHeaderBack(`/settings/reconcilers-group/${this.props.match.params.group_id}`)
            this.setState({
                our_service_options: {},
            their_service_options: {},
            step: 0,
            our_col_options: {},
            their_col_options: {},
            })

            this.group_id=this.props.match.params.group_id;
            this.get_group.forId(this.group_id).execute()
            // this.handleSourceQuery(null, 'our_data_type_options', { id: this.props.form_data.our_data_type_id });
            // this.handleSourceQuery(null, 'their_data_type_options', { id: this.props.form_data.their_data_type_id });

            // if (this.props.form_data.our_data_type_id) {
            //     this.handleServiceQuery(null, 'our_service_options', { id: this.props.form_data.our_data_service_id });

            // }
            // if (this.props.form_data.their_data_type_id) {
            //     this.handleServiceQuery(null, 'their_service_options', { id: this.props.form_data.their_data_service_id });
            // }
            // console.log("changes found",this.props)
        }
    }

}

export default withDomains(ReconcilerAddEdit, "settings", "datatype");
